import { Card, CardContent, cn } from '@up2stay/up2promo-ui';
import type { CSSProperties, ReactNode } from 'react';

/** Profiles SoT section title (`--t-h3`) for Template detail cards. */
export const TEMPLATE_DETAIL_SECTION_TITLE_CLASS =
  'text-[15.5px] font-bold leading-tight text-foreground';

/** Profiles SoT body (`--t-body`). */
export const TEMPLATE_DETAIL_BODY_CLASS =
  'text-[13.5px] leading-relaxed text-foreground';

/** Profiles SoT muted body. */
export const TEMPLATE_DETAIL_MUTED_CLASS =
  'text-[13.5px] leading-relaxed text-muted-foreground';

/** Profiles SoT label (`--t-label`). */
export const TEMPLATE_DETAIL_LABEL_CLASS =
  'text-[11px] font-semibold uppercase tracking-[0.6px] text-muted-foreground';

type TemplateDetailSectionCardProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  style?: CSSProperties;
};

/**
 * Shared Template-detail section shell — Card + Profiles density (`p-5 sm:p-6`).
 */
export function TemplateDetailSectionCard({
  children,
  className,
  contentClassName,
  style,
}: TemplateDetailSectionCardProps) {
  return (
    <Card className={cn('min-w-0 overflow-hidden', className)} style={style}>
      <CardContent
        className={cn('flex flex-col gap-3 p-5 sm:p-6', contentClassName)}
      >
        {children}
      </CardContent>
    </Card>
  );
}
